import { timePeriodsFactory, monthFactory } from './categories';

const getRaceType = val => val.split('/')[1].match(/jumps|flat/)[0];

const timePeriodReducer = (timePeriod, { type, value }) => {
    const { flatOrJumps, seasonsAvailable } = timePeriod.createdBy;
    if (type === 'raceType' && flatOrJumps !== getRaceType(value)) {
        return timePeriodsFactory(value, seasonsAvailable);
    }
    return timePeriod;
};

const monthReducer = (month, { type, value }) => {
    const { flatOrJumps, timePeriod, seasonsAvailable } = month.createdBy;
    if (type === 'raceType' && flatOrJumps !== getRaceType(value)) {
        return monthFactory(value, timePeriod, seasonsAvailable);
    }
    if (type === 'timePeriod' && timePeriod !== value) {
        return monthFactory(flatOrJumps, value, seasonsAvailable);
    }
    return month;
};

const categoriesReducer = ({ raceType, timePeriod, month }, action) => ({
    raceType,
    timePeriod: timePeriodReducer(timePeriod, action),
    month: monthReducer(month, action),
});

export default categoriesReducer;



// WEBPACK FOOTER //
// ./src/js/horse/progenyResults/reducer.js